import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccordionItem from '../../containers/accordion-item';
import Wysiwyg from '../../containers/wysiwyg';
import Html from '../../containers/html';
import OneColumnLayout from '../../containers/one-column-layout';
import TwoColumnLayout from '../../containers/two-column-layout';
import ThreeColumnLayout from '../../containers/three-column-layout';
import FourColumnLayout from '../../containers/four-column-layout';

const AccordionItemBlock = props => <AccordionItem {...props} />;
AccordionItemBlock.displayName = 'AccordionItem';

export default withDynamicComponents({
  componentWhitelist: [
    Wysiwyg,
    Html,
    OneColumnLayout,
    TwoColumnLayout,
    ThreeColumnLayout,
    FourColumnLayout
  ],
  mapInputToOutput: [
    
  ],
})(AccordionItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/accordion-item/index.jsx